module.exports = __webpack_public_path__ + "img/prestashop.194ca196.webp";